import { render } from "./gaji-list-gabung.vue?vue&type=template&id=5f2a4b83"
import script from "./gaji-list-gabung.vue?vue&type=script&lang=js"
export * from "./gaji-list-gabung.vue?vue&type=script&lang=js"

import "./gaji-list-gabung.vue?vue&type=style&index=0&id=5f2a4b83&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__